import { useTranslation } from "../i18n/useTranslation";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";

/**
 * Simple language picker dropdown. Saves selection to localStorage so it
 * persists across sessions. Drop it anywhere — Settings menu, navbar, footer.
 */
export function LanguageSwitcher({ className = "" }) {
  const { locale, setLocale, locales } = useTranslation();
  const active = locales.find((l) => l.code === locale);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`rounded-full text-xs ${className}`}
          data-testid="lang-switcher"
          aria-label="Change language"
        >
          <Globe className="w-4 h-4 mr-1" />
          {active?.label || locale.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {locales.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLocale(l.code)}
            data-testid={`lang-option-${l.code}`}
            className={l.code === locale ? "font-semibold text-sage" : ""}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
